import BasicDialog, { DialogProps } from 'components/atoms/Dialog/Dialog';
import React, { FunctionComponent, useEffect } from 'react';

interface ModalProps extends DialogProps {
  closeOnEscapeKeyDown?: boolean;
}

const ModalWrapper: FunctionComponent<React.PropsWithChildren<ModalProps>> = ({
  children,
  onClose,
  isOpen,
  closeOnDialogClick,
  closeOnEscapeKeyDown = true,
  sx,
  contentSx,
  maxWidth,
  fullWidth,
}) => {
  useEffect(() => {
    if (!closeOnEscapeKeyDown) {
      return undefined;
    }

    const onEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onEscape);

    return () => {
      document.removeEventListener('keydown', onEscape);
    };
  }, [closeOnEscapeKeyDown, onClose]);

  return (
    <BasicDialog
      onClose={onClose}
      isOpen={isOpen}
      closeOnDialogClick={closeOnDialogClick}
      sx={sx}
      contentSx={contentSx}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      {children}
    </BasicDialog>
  );
};

export default ModalWrapper;
